import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import { Team } from '@yandex-int/k-common/typings';
import { get, isNil } from 'lodash';
import { createSelector } from 'reselect';

import { getCurrentClass } from 'common.components/user/selectors';
import { getClassIdFromProps } from 'utils/selectors/selectors';

import { ReduxTeacherStore } from '../../typings';

import { CLASS_GRADES_TO_ARCHIVE, PAGES } from './new-year-modal.constants';

const newYearModalSelector = (storeState: ReduxTeacherStore) => get(storeState, 'newYearModal');

export const getPage = createSelector(newYearModalSelector, (state): PAGES.ARCHIVE | PAGES.RENAME => state.page);

export const getNewName = createSelector(
    [newYearModalSelector, getCurrentClass],
    (state, currentClass: Team): string => (state.newName === null ? currentClass.name : state.newName)
);

export const getNewLevel = createSelector(newYearModalSelector, (state): number => state.newLevel);

export const getWasModalClosedForCurrentClass = createSelector(
    [newYearModalSelector, getClassIdFromProps],
    (state, currentClassId: number | null): boolean => {
        if (!currentClassId) {
            return false;
        }

        return state.closed[currentClassId];
    }
);

export const getShouldShowNewYearModal = createSelector(
    [getCurrentClass, getWasModalClosedForCurrentClass],
    (currentClass, wasModalClosedForCurrentClass): boolean => {
        return (
            Boolean(currentClass) &&
            !currentClass?.actual &&
            Boolean(currentClass?.is_supervisor) &&
            !wasModalClosedForCurrentClass
        );
    }
);

export const getLoadingStatus = createSelector(newYearModalSelector, (state): LOADING_STATUSES => state.loadingStatus);

export const getIsModalOpened = createSelector(
    [newYearModalSelector, getClassIdFromProps],
    (state, currentClassId: number | null): boolean => {
        if (isNil(currentClassId)) {
            return true;
        }

        return state.closed[currentClassId] ? !state.closed[currentClassId] : true;
    }
);

export const getShouldArchiveClass = createSelector(getCurrentClass, (currentClass: Team): boolean =>
    CLASS_GRADES_TO_ARCHIVE.includes(currentClass.level)
);
